var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchContext } from "@react-components/modules/Search/SearchProvider/useSearchContext";
import { CollectionRoot } from "@react-components/primitives/Collection/CollectionRoot/CollectionRoot";
import { CollectionEntries } from "@react-components/primitives/Collection/CollectionEntries/CollectionEntries";
import { CardRenderer } from "@react-components/ui/Cards/CardRenderer";
import { CollectionLoadMore } from "@react-components/primitives/Collection/CollectionPagination/CollectionLoadMore/CollectionLoadMore";
import { useDictionaryContext } from "@contexts/dictionary-context/useDictionaryContext";
var SearchResult = function (_a) {
    var showLoadMore = _a.showLoadMore;
    var _b = useSearchContext(), searchCollection = _b.searchCollection, isLastPage = _b.isLastPage, setSize = _b.setSize, searchLocation = _b.searchLocation;
    var loadMore = useDictionaryContext().dictionary.loadMore;
    return searchLocation === "internal" ? (_jsxs(CollectionRoot, { children: [_jsx(CollectionEntries, { collection: searchCollection === null || searchCollection === void 0 ? void 0 : searchCollection.flatMap(function (x) { return x.collection; }), renderEntry: function (entry) { return (_jsx("div", __assign({ className: "mb-4" }, { children: _jsx(CardRenderer, { componentType: entry.alias, props: entry }, void 0) }), "search-collection-entry-" + entry.id)); } }, void 0), showLoadMore && (_jsx("div", __assign({ className: "search__load-more-button-wrap" }, { children: _jsx(CollectionLoadMore, __assign({ disable: isLastPage, onClick: function () {
                        return !isLastPage &&
                            setSize &&
                            setSize(function (size) { return size + 1; });
                    } }, { children: loadMore }), void 0) }), void 0))] }, void 0)) : null;
};
export { SearchResult };
